import { createRouter, createWebHashHistory, type RouteRecordRaw } from 'vue-router';
import MainView from '@/components/MainView.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: MainView
  }
];

const router = createRouter({
  // hash history is required for ez2view time travel since it always adds the dispatch interval to the fragment
  // i.e. after the hash
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes
});

// handle backward compatible url rewrites
// router.beforeEach((to, _, next) => {
//   if (to.fullPath.slice(0, 2) === '/#') {
//     // if fullPath begins with a hash (ignore hashes later in path) remove the hash
//     const path = to.fullPath.slice(2);
//     next(path);
//     return;
//   }
//   next();
// });

// fix ugly url's that may have persisted while not in hash history mode by just using the hash as the location
// e.g. https://localhost:5902/?dispatchInterval=2023-11-17-1345&isRealTime=true#/?dispatchInterval=2023-11-17-1045&isRealTime=false
// is changed to https://localhost:5902/#/?dispatchInterval=2023-11-17-1045&isRealTime=false
if (location.search) {
  location.replace(`/${location.hash}`);
}

export default router;
